// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "form[data-v-9630e642]{max-width:640px}.loading-image[data-v-9630e642]{display:inline-block;margin-right:5px;width:20px}", ""]);
// Exports
module.exports = exports;
